import { cn } from '@/lib/utils'
import dayjs from 'dayjs'
import { useEffect, useState } from 'react'
import { axiosInstance } from 'service/api/axios'
import { Tooltip } from '../ui/tooltip'

const path = new URL(axiosInstance.defaults.baseURL + '/v1/now/sse')

function useServerTime() {
    const locale = navigator.language || 'pt-BR'
    const clienteTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone
    const [time, setTime] = useState(dayjs().tz(clienteTimezone))

    const [{ value: timezone }] = new Intl.DateTimeFormat(locale, {
        timeZoneName: 'long',
    })
        .formatToParts(new Date())
        .filter(part => part.type === 'timeZoneName')

    useEffect(() => {
        const eventSource = new EventSource(path.toString())

        eventSource.onmessage = ({ data }) => {
            const event = JSON.parse(data)
            setTime(dayjs(event.data).tz(clienteTimezone))
        }

        return () => {
            eventSource.close()
        }
    }, [])

    return { time, timezone }
}

export function ServerSideClock({ className }: { className?: string }) {
    const { time, timezone } = useServerTime()

    return (
        <Tooltip title="A hora segue o fuso horário da máquina.">
            <div className={cn('flex flex-col items-center gap-1', className)}>
                <span className="text-6xl font-semibold tracking-tight tabular-nums">
                    {time.format('HH:mm:ss')}
                </span>
                <span className="text-muted-foreground text-sm">
                    {time
                        .format('dddd, LL')
                        .replace(/^\w/, c => c.toUpperCase())}
                </span>
                <span className="text-muted-foreground text-xs">
                    {timezone}
                </span>
            </div>
        </Tooltip>
    )
}
